import * as actionTypes from './actionTypes';
import i18n from "i18next";

export const updateLanguageSuccess = (lng) => {
    return {
        type: actionTypes.MENU_UPDATE_LANGUAGE_SUCCESS,
        lng: lng
    }
}

export const updateLanguage = (lng) => {
    return dispatch => {
        i18n.changeLanguage(lng)
            .then(() => {
                dispatch(updateLanguageSuccess(lng));
            });
    }
}

export const updateMenuTopic = (topic) => {
    return {
        type: actionTypes.MENU_UPDATE_TOPIC,
        topic: topic
    }
}
